import './navbar.css';
// eslint-disable-next-line import/named
import { CustomUserClaim } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { config } from '../../utils/config/config';
function ensureArray(customClaim: CustomUserClaim | CustomUserClaim[]): CustomUserClaim[] {
    // Vérifie si 'customClaim' est déjà un tableau
    // eslint-disable-next-line unicorn/prefer-ternary
    if (Array.isArray(customClaim)) {
        return customClaim;
    } else {
        // Si ce n'est pas un tableau, on l'encapsule dans un tableau
        return [customClaim];
    }
}
/**
 * @function NavBar displays the desktop version of the navigation menu
 * @returns {JSX.Element} HTML content
 */
function NavBar() {
    const { authState } = useOktaAuth();
    const groups = authState!.idToken!.claims.groups;
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const handleNavigation = (path: string) => {
        window.location.href = path; // Change l'URL et recharge la page
    };
    
    return (
        <ul className="flex sticky justify-between navigationBar sm:flex hidden">
            <div className="flex">
                {/* Utilisation de onClick au lieu de Link */}
                <li className="navigationElement" onClick={() => handleNavigation('/')}>Réservation</li>
                <li className="navigationElement" onClick={() => handleNavigation('/informations')}>Informations</li>
                <li className="navigationElement" onClick={() => handleNavigation('/charte')}>Charte Coworking</li>
                <li className="navigationElement" onClick={() => handleNavigation('/restaurants')}>Restaurants</li>
                {ensureArray(groups).includes(`GG_APCOWORK_${config.ENV_GROUP}_EDITOR`) ?
                <>
                    <li className="navigationElement" onClick={() => handleNavigation('/articles')}>Articles</li>
                </>
                : <>
                </>}
                
            </div>
            <div className="flex">
                {/* Ce lien est poussé à droite */}
                {/* <li className="navigationElement" onClick={() => handleNavigation('/profil')}>Mon Profil</li> */}
            </div>
            
        </ul>


    );
}

export { NavBar };